import { api } from ".";

export const postBatchCancellationRequest = async (
    uid: string
    ): Promise<string> => {
  await api.post<void>(
    `batch/cancel-batch/${uid}`,
  );
  return `Lote ${uid} cancelado com sucesso`;
};